import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from './services/toaster.service';
import { TranslateModule } from '@ngx-translate/core';
import { InfoServiceDialogComponent } from './components/alert-service-dialog/info-service-dialog.component';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    declarations: [
        ConfirmationDialogComponent,
        InfoServiceDialogComponent,
        LoadingDialogComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatProgressBarModule,
        MatSnackBarModule,
        TranslateModule,
        MatProgressSpinnerModule
    ],
    exports: [
        ConfirmationDialogComponent,
        InfoServiceDialogComponent,
        LoadingDialogComponent
    ],
    entryComponents: [
        ConfirmationDialogComponent,
        InfoServiceDialogComponent,
        LoadingDialogComponent
    ],
    providers: [
        ToasterService
    ]
})
export class UserInteractionModule { }
